import React from 'react'
import propTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  changeGenrePage,
  setCurrentMovie,
  setPreviousMovie,
  nextMovie,
  setCategoryMovieList
} from '../../../action/VodAction';
import MovieInfo from '../movie-info/moiveInfo'
import defaultImagePic from '../../../images/thumb_movie.jpg'
import { VODSearchColor } from '../../../JS/setColors'

class MovieList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      noImage: [],
      currentMovieList: []
    }
  }
  goBack = () => {
    this.props.changeGenrePage(0);
  }
  componentDidMount() {
    this.getMovieList();
    VODSearchColor(this.props.menuColor)
  }
  showMovieInfo = (current, currentIndex) => {
    let previous = null, previousFlag = false, nextFlag = true;
    this.props.setCurrentMovie(current);
    // console.log("index", this.props.category);
    if (this.state.currentMovieList.length > 0) {
      this.state.currentMovieList.map((iterator, index) => {
        if (nextFlag && currentIndex < index) {
          nextFlag = false
          //console.log("next", iterator.videoTitle);
          this.props.nextMovie(iterator);
        }
        if (currentIndex > index) {
          previousFlag = true;
          previous = iterator;
          // console.log("previous", previous.videoTitle);
        }
      })
      if (previousFlag) {
        this.props.setPreviousMovie(previous);
      } else {
        this.props.setPreviousMovie(null);
      }
      if (nextFlag) {
        this.props.nextMovie(null);
      }
    }

  }
  imageNotfound = (id) => {
    let noImageA = [...this.state.noImage];
    noImageA.push(id);
    //console.log("image not found.", noImageA);
    this.setState({ noImage: noImageA })
  }
  getMovieList = () => {
    let flag = false, langMatch = false;
    let catMovieList = [];
    if (this.props.movieList) {
      this.props.movieList.map((iterator, index) => {
        iterator.category.map((it, index) => {
          if (it === this.props.category.index) {
            flag = true;
          }
        })
        if (flag) {
          flag = false
          if (this.props.lang) {
            iterator.language.map((iterator, index) => {
              if (iterator === `${this.props.langIndex}`) {
                langMatch = true
              }
            })
            if (langMatch) {
              langMatch = false
              catMovieList.push(iterator)
            }
          } else {
            catMovieList.push(iterator);
          }
        }
      })
      this.setState({ currentMovieList: catMovieList });
      this.props.setCategoryMovieList(catMovieList);
    }
  }
  render() {
    return (
      <div>
        {!this.props.currentMovie ?
          <div id="movie-genre-item" className="movie-widgets">
            <div
              className="search-back"
              data-target="movie-search-genre"
              onClick={this.goBack}
              style={{ color: "#ffffff" }}>
              <i className="fa fa-chevron-left" style={{ color: "inherit" }}></i>
              Back
         </div>
            <h4>Results for:</h4>
            <ul className="movie-widgets-list">
              {
                this.state.currentMovieList.length > 0 ?
                  this.state.currentMovieList.map((iterator, index) => {
                    return (
                      < li
                        id="resume-play"
                        className="default"
                        data-target=""
                        onClick={() => { this.showMovieInfo(iterator, index) }}
                        style={{
                          background: ` url('${this.state.noImage.indexOf(iterator.videoId) === -1 ?
                            iterator.promoImageUrl : defaultImagePic}') center center no-repeat`,
                          backgroundSize: "cover",
                        }}>
                        <img style={{ display: "none" }} alt="not found"
                          src={iterator.promoImageUrl}
                          onError={() => { this.imageNotfound(iterator.videoId) }} />
                        <span className="movie-thumb-text">{iterator.videoTitle}</span>
                      </li>
                    )
                  }) : null
              }
            </ul>
          </div> :
          <MovieInfo category={this.props.category} />
        }
      </div>
    )
  }
}

MovieList.propTypes = {
  category: propTypes.string
}

const mapStateToProps = state => {
  return {
    movieList: state.store.vod.VODData ?
      state.store.vod.VODData.channelList : null,
    lang: state.store.vod.lang.currentLang,
    langIndex: state.store.vod.lang.currentLangIndex,
    currentMovie: state.store.vod.currentMovie,
    menuColor: state.store.home.MenuColor
  }
}

export default connect(
  mapStateToProps, {
  changeGenrePage,
  setCurrentMovie,
  setPreviousMovie,
  nextMovie,
  setCategoryMovieList
}
)(MovieList);